import { getCookie } from "@/src/utils/browser"
import { computeHomeAiEnabled } from "@/src/utils/ai/homeAiEnablement"
import { useEffect, useState } from "react"
import useGetSearchQueryURL from "../srp/getSearchQueryURL"
import { useGetSearchParamsObj } from "../srp/searchParams"

interface AiFeatureFlags {
    homeAISearch: boolean
    srpSmartFilterSort: boolean
}

export const useAIFeatureEnableManager = (initialEnabled = false): AiFeatureFlags => {
    const { isSeoQuery } = useGetSearchParamsObj()
    const { isMulticity, isRTSplitView } = useGetSearchQueryURL()
    const [aiFeatureEnabled, setAiFeatureEnabled] = useState<AiFeatureFlags>({
        homeAISearch: initialEnabled,
        srpSmartFilterSort: initialEnabled
    })

    useEffect(() => {
        // AI flow is disabled for the RT split view (smart sort, AI filter, floating chat all gate on srpSmartFilterSort).
        if (isSeoQuery || isMulticity || isRTSplitView) return
        const isActiveAIMode = computeHomeAiEnabled(getCookie)
        setAiFeatureEnabled({
            homeAISearch: isActiveAIMode,
            srpSmartFilterSort: isActiveAIMode
        })
        // These are stable today (derived from the URL + a static flag), so behaviour is unchanged;
        // listing them keeps the AI gate correct if RT_SPLIT_VIEW_ENABLED later becomes async (AB/remote config).
    }, [isSeoQuery, isMulticity, isRTSplitView])

    return aiFeatureEnabled
}
